const FrameGlassType = {
  Doff: "doff",
  Translucent: "translucent",
};

const ResumeType = {
  ATS: "ats",
  Modern: "modern"
}

export { FrameGlassType,ResumeType };
